import { Controller } from "@hotwired/stimulus"

// A job card's title or place chip (assistants/_job_card): the posting in the fixed
// right sidebar, the same one /messages and Network open their details in (msg-detail's
// layout copy, via "jane:open-conversation"). Where that sidebar cannot open (a phone,
// a page without the app shell) the link is followed: the posting itself, in a new tab.
export default class extends Controller {
    open(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

        let { url, key } = event.params
        if (!url) return

        let detail = { url, key, handled: false }
        window.dispatchEvent(new CustomEvent("jane:open-conversation", { detail }))
        if (detail.handled) event.preventDefault()
    }
}
